import { createContext, useContext } from 'react';
import type { Role } from '@torapon/shared';

/** ログインしているスタッフ（名前は Firestore の staff から引く） */
export type Me = { id: string; officeId: string; role: Role };
export const MeCtx = createContext<Me | null>(null);
export const useMe = () => useContext(MeCtx);
